import { createFileRoute } from "@tanstack/react-router"
import { BuyingComparisonReport } from "@/features/reports/components/BuyingComparisonReport"
import {
  applyBuyingComparisonDefaults,
  buyingComparisonQuery,
  BuyingComparisonSearchParams,
} from "@/features/reports/core/hooks/useBuyingComparisonReport"

export const Route = createFileRoute("/(authenticated)/reports/buying-comparison")({
  validateSearch: BuyingComparisonSearchParams,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps: search }) => {
    void context.queryClient.ensureQueryData(
      buyingComparisonQuery(applyBuyingComparisonDefaults(search)),
    )
  },
  component: BuyingComparisonReport,
})
